import { render, staticRenderFns } from "./bank-icon.vue?vue&type=template&id=47a4d164&scoped=true&"
import script from "./bank-icon.vue?vue&type=script&lang=js&"
export * from "./bank-icon.vue?vue&type=script&lang=js&"
import style0 from "./bank-icon.vue?vue&type=style&index=0&id=47a4d164&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a4d164",
  null
  
)

export default component.exports